import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Wifi, Tv, Phone, MapPin } from 'lucide-react';
import { configAPI } from '../services/api';

export default function LandingPage() {
  const [config, setConfig] = useState({ companyName: 'Laxmi Cable Vision', companyPhone: '', companyAddress: '' });

  useEffect(() => {
    configAPI.get().then(({ data }) => data?.data && setConfig(data.data)).catch(() => {});
  }, []);

  const waLink = config.companyPhone
    ? `https://wa.me/91${config.companyPhone.replace(/\D/g, '').slice(-10)}`
    : null;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
      {/* Header */}
      <header style={{
        background: 'var(--bg-sidebar)', color: '#fff', padding: '14px 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 10,
      }}>
        <div style={{ fontWeight: 800, fontSize: '1.15rem' }}>
          {config.companyName}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link to="/portal/login" style={{ textDecoration: 'none' }}>
            <button className="btn btn-secondary btn-sm" style={{ background: 'transparent', color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>
              Customer Login
            </button>
          </Link>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <button className="btn btn-primary btn-sm">Staff / Agent Login</button>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, var(--bg-sidebar), #1e3a5f)', color: '#fff',
        padding: '64px 24px', textAlign: 'center',
      }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, margin: '0 0 12px' }}>
          Fast Broadband & CableTV, Delivered Right
        </h1>
        <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,.75)', maxWidth: 560, margin: '0 auto 28px' }}>
          {config.companyName} brings reliable fiber internet and cable television to your home —
          local support, transparent billing, no surprises.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {waLink && (
            <a href={waLink} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
              <button className="btn" style={{ background: '#25D366', color: '#fff', border: 'none', padding: '11px 22px', fontWeight: 700 }}>
                <Phone size={15} /> Enquire on WhatsApp
              </button>
            </a>
          )}
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '48px 24px', maxWidth: 1000, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20 }}>
          {[
            { icon: Wifi, title: 'High-Speed Fiber', desc: 'Reliable broadband plans built for streaming, work-from-home and gaming.' },
            { icon: Tv, title: 'CableTV', desc: 'Wide channel lineup with HD options and flexible packages.' },
            { icon: Phone, title: 'Local Support', desc: 'Fast complaint resolution and doorstep service from our local team.' },
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="card" style={{ padding: 22, textAlign: 'center' }}>
              <div style={{
                width: 48, height: 48, borderRadius: '50%', background: 'var(--primary-light)', color: 'var(--primary)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
              }}>
                <Icon size={22} />
              </div>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>{title}</div>
              <div style={{ fontSize: '.85rem', color: 'var(--text-muted)' }}>{desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: 'var(--bg-sidebar)', color: 'rgba(255,255,255,.7)', padding: '28px 24px', textAlign: 'center', fontSize: '.85rem' }}>
        <div style={{ fontWeight: 700, color: '#fff', marginBottom: 8 }}>{config.companyName}</div>
        {config.companyAddress && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, marginBottom: 4 }}>
            <MapPin size={13} /> {config.companyAddress}
          </div>
        )}
        {config.companyPhone && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
            <Phone size={13} /> {config.companyPhone}
          </div>
        )}
        <div style={{ marginTop: 14, fontSize: '.72rem', color: 'rgba(255,255,255,.4)' }}>
          © {new Date().getFullYear()} {config.companyName}. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
